import EntityModel from '@/common/models/entity-model';

export default class CustomFieldsModel extends EntityModel {
    hydrate({
        name = null,
        type = null,
        description = null,
        isUsed = null,
        additionalSchema = null,
    } = {}) {
        this.name = name;
        this.type = type;
        this.description = description;
        this.isUsed = isUsed;
        this.additionalSchema = additionalSchema;
        this.enableRestrictions = !!this.additionalSchema;
    }

    getPayload() {
        let additionalSchema = null;
        if ((this.type === 'array' || this.type === 'string')
            && this.enableRestrictions) {
            // eslint-disable-next-line prefer-destructuring
            additionalSchema = this.additionalSchema;
        }
        return {
            name: this.name.replace(/\s/g, '-'),
            type: this.type,
            description: this.description,
            isUsed: this.isUsed,
            additionalSchema,
        };
    }
}
